module.exports = __webpack_public_path__ + "img/tejal-yoga_banner.d0409a78.jpg";